/** findElement 함수를 Object 하위의 프로토타입으로 설정하는 것은 어떠한지 궁금합니다 */
export const findElement = (selector) => document.querySelector(selector);

export const parseValueFromNode = (node) => node.value;

export const isCancelModal = (className) =>
  className.includes('modal-cancel-button') || className.includes('modal-wrapper');
